const routes = {
  root: "/",
  facility: "/facility/:facilityId",
  assets: "/facility/:facilityId/assets",
  reports: "/facility/:facilityId/reports/:reportName",
  alerts: "/facility/:facilityId/alerts",
  utilization: "/facility/:facilityId/utilization",
  utilizationDetail: "/facility/:facilityId/utilization/:deviceTypeId",
  support: "/support",
}

export default routes
